import { RootState } from '../../store';
import { prepareSettingsByCurrentAccount } from '../../../services/services';
import {
  TAllMetricsPreferences,
  TMetricsPreferences,
  TGlobalMetric,
  TGlobalMetricPreferenceValue,
  TInsightsCards,
  TInsightsFilters,
  TInsightsFiltersPreferenceValue
} from '../types';

export const updatePreferences = (
  account: string,
  newSetting:
    | TGlobalMetricPreferenceValue
    | TMetricsPreferences
    | TInsightsFiltersPreferenceValue,
  nodeSettings: TGlobalMetric[] | TAllMetricsPreferences[] | TInsightsFilters[]
): TGlobalMetric[] | TAllMetricsPreferences[] => {
  return (
    nodeSettings as Array<
      TGlobalMetric | TAllMetricsPreferences | TInsightsFilters
    >
  ).map(
    (setting: TGlobalMetric | TAllMetricsPreferences | TInsightsFilters) => {
      if (setting?.current_account_id === account) {
        return {
          ...setting,
          ...newSetting
        };
      }
      return setting;
    }
  );
};

export const createPreferences = (
  account: string,
  newSetting: TGlobalMetricPreferenceValue | TMetricsPreferences,
  nodeSettings: TGlobalMetric[] | TAllMetricsPreferences[]
): TGlobalMetric[] | TAllMetricsPreferences[] => {
  const newSettingCompleted = {
    current_account_id: account,
    ...newSetting
  } as TGlobalMetric | TAllMetricsPreferences;
  const nodeSettingsUpdated = [...nodeSettings];

  nodeSettingsUpdated.push(newSettingCompleted);

  return nodeSettingsUpdated;
};

export const getInsightsCardsByCurrentAccount = (
  state: RootState
): TInsightsCards | null => {
  const { current_account_id } = state.userPreferences.settings.vrr;
  const { cards } = state.userPreferences.settings.insights;

  return prepareSettingsByCurrentAccount(
    current_account_id,
    cards
  ) as TInsightsCards;
};
